// Obtengo la direccion ip del cliente y el registro por si ya habia votado  //

import React, { useState, createContext } from "react";

const PollContext = createContext({});

export function PollContextProvider({ children }) {
  const [voted, setVoted] = useState({
    voted: false,
    ip: "",
  });

  return (
    <PollContext.Provider value={{ voted, setVoted }}>
      {children}
    </PollContext.Provider>
  );
}

export default PollContext;
